import type { EventId, PlanEvent } from "../../../../shared/types";
import type { RecurrenceToastState } from "./RecurrenceActionToast";

interface UseEditingEventDeleteParams {
  readonly events: PlanEvent[];
  readonly onDeleteEvent: (id: EventId, expandedEvent?: PlanEvent, skipRecurrenceCheck?: boolean) => void;
  readonly onSetEditingEvent: (event: PlanEvent | null) => void;
  readonly onSetRecurrenceToast: (toast: RecurrenceToastState | null) => void;
  readonly onAddRecurrenceException?: (baseId: EventId, date: string) => void;
  readonly onUndoEvent?: () => void;
}

function extractBaseId(instanceId: string, instanceDate: string): EventId {
  const suffix = `_${instanceDate}`;
  if (instanceId.endsWith(suffix))
    return instanceId.slice(0, -suffix.length) as EventId;
  return instanceId as EventId;
}

export function useEditingEventDelete({
  events,
  onDeleteEvent,
  onSetEditingEvent,
  onSetRecurrenceToast,
  onAddRecurrenceException,
  onUndoEvent,
}: UseEditingEventDeleteParams) {
  const handleDelete = (id: EventId) => {
    const evt = events.find((e) => e.id === id);
    if (evt?.recurrence?.type) {
      const baseId = extractBaseId(id as string, evt.date);
      onAddRecurrenceException?.(baseId, evt.date);
      onSetEditingEvent(null);
      onSetRecurrenceToast({
        message: "Jour retiré de la série",
        applyAllLabel: "Supprimer tout",
        onUndo: () => onUndoEvent?.(),
        onApplyAll: () => {
          onUndoEvent?.();
          setTimeout(() => onDeleteEvent(baseId, undefined, true), 0);
        },
      });
    } else {
      onDeleteEvent(id);
      onSetEditingEvent(null);
    }
  };

  return { handleDelete };
}
